import React from "react";

export const Logo = ({ className = "h-9 w-9" }) => (
  <img
    src="/assets/logo.png"
    alt="IBH Logo"
    className={`${className} object-contain rounded-xl`}
    data-testid="ibh-logo"
  />
);

export const Wordmark = ({ light = false, context = "" }) => (
  <a href="/" className="flex items-center gap-2.5 no-underline" data-testid="brand-wordmark">
    <Logo />
    <div className="leading-tight">
      <div
        className={`font-display text-[20px] font-bold tracking-tight ${
          light ? "text-white" : "text-slate-900"
        }`}
      >
        India Business Helpline {context && <span className="sr-only">({context})</span>}
      </div>
    </div>
  </a>
);